import type { WhoAmI } from '@/stores'
import { useAuthStore } from '@/stores'
import { storeToRefs } from 'pinia'

export class RoleHelper {
  private readonly wai: Ref<WhoAmI | undefined>
  readonly beta = computed<boolean | undefined>(() => this.wai.value?.roles?.includes('ROLE_BETA_TESTER'))
  readonly developer = computed<boolean | undefined>(() => this.wai.value?.roles?.includes('ROLE_DEVELOPER'))
  readonly impersonator = computed<boolean | undefined>(() => this.wai.value?.roles?.includes('ROLE_ALLOWED_TO_SWITCH'))
  readonly user = computed<boolean | undefined>(() => this.wai.value?.roles?.includes('ROLE_USER'))
  readonly api_user = computed<boolean | undefined>(() => this.wai.value?.roles?.includes('ROLE_API_USER'))
  readonly admin = computed<boolean | undefined>(() => this.wai.value?.roles?.includes('ROLE_ADMIN'))
  readonly api_admin = computed<boolean | undefined>(() => this.wai.value?.roles?.includes('ROLE_API_ADMIN'))
  readonly db_auditor = computed<boolean | undefined>(() => this.wai.value?.roles?.includes('ROLE_DB_AUDITOR'))
  readonly management = computed<boolean | undefined>(() => this.wai.value?.roles?.includes('ROLE_MANAGEMENT'))
  readonly whistleblow_agent = computed<boolean | undefined>(() => this.wai.value?.roles?.includes('ROLE_WHISTLEBLOW_AGENT'))
  readonly worktime_selfedit = computed<boolean | undefined>(() => this.wai.value?.roles?.includes('ROLE_WORKTIME_SELFEDIT'))
  readonly department_leader = computed<boolean | undefined>(() => this.wai.value?.roles?.includes('ROLE_DEPARTMENT_LEADER'))
  readonly error_tracker_editor = computed<boolean | undefined>(() => this.wai.value?.roles?.includes('ROLE_ERROR_TRACKER_EDITOR'))
  readonly module_editor = computed<boolean | undefined>(() => this.wai.value?.roles?.includes('ROLE_MODULE_EDITOR'))
  readonly sales_person = computed<boolean | undefined>(() => this.wai.value?.roles?.includes('ROLE_SALES_PERSON'))
  readonly AllRoles = computed<string[] | undefined>(() => this.wai.value?.roles)

  constructor() {
    const { whoami } = storeToRefs(useAuthStore())
    this.wai = whoami as Ref<WhoAmI | undefined>
  }

  has(roleName: string): boolean | undefined {
    const ar = unref(this.AllRoles)
    if (!ar) return undefined
    const roleKey = roleName.toUpperCase()
    return ar.includes(roleKey)
  }
}
